// ==============================|| LOGO ICON SVG ||============================== //

export default function LogoIcon() {
  return (
    <svg width="64" height="64" viewBox="-10 -10 280 280" xmlns="http://www.w3.org/2000/svg">
      <path
        fill="#b59343"
        d="M68.1,256.9C31.7,240.4,3.2,196.3.3,151.9-2.9,103.9,22.9,53.8,66.1,24.5,107.7-3.8,157.3-7.8,202.2,13.6c34.2,16.3,55.1,50.6,56,92,1,46.9-23.4,90.3-62.1,110.7-41.7,21.9-95.4,19.4-124.9-6-22.3-19.1-28.2-47.8-16.8-80.7,15.2-43.7,55.4-65.7,85.2-71.2,25.1-4.6,46.9.7,58.5,14.3,6.8,8,13.1,22.3,4.8,45.1-18.9,51.6-108.6,52.4-130.6,51.8,1.8,9.3,6.4,17.2,13.7,23.5,22.5,19.3,66.2,20.7,99.6,3.1,31.2-16.4,50.9-51.8,50.1-90.2-.7-33.1-16.4-59.4-43.1-72.1-37.4-17.8-78.9-14.4-113.7,9.3-36.7,24.9-58.6,67-56,107.2,2.4,35.9,25.9,72.9,54.6,85.9l-9.3,20.6ZM72.8,147c29.7,1,96.6-3.8,108.7-37,3.7-10.1,3.4-17.8-.8-22.8-6-7.1-20.6-9.8-37.1-6.7-23.9,4.4-56,21.9-68,56.4-1.2,3.4-2.1,6.8-2.9,10Z"
      />
    </svg>
  );
}
